















































































































import { appModule } from "@/store/modules/app";
import { storeResume } from "@/store/modules/resume";
import { userModule } from "@/store/modules/user";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import moment from "moment";
import storeBilling from "@/store/modules/Billing";
import RegisterKunjunganSvc from "@/services/RegisterKunjungan";
import Billing from "@/services/Billing";
import { storeDokter } from "@/store/modules/dokter";
import DataPasien from "@/services/DataPasien";
import CardModalAksesTindakan from "@/components/modal/CardModalAksesTindakan.vue";
import LockingRegister from "@/utility/LockingRegister";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { storePasien } from "@/store/modules/pasien";
import CardTindakan from "@/components/pemeriksaan/pelayanan/CardTindakan.vue";

@Component({
  components: {
    CardModalAksesTindakan,
    CardTindakan,
  },
  beforeRouteLeave(to, from, next) {
    LockingRegister.unlockRegister("klinik");
    storePasien.CLEAR_PASIEN();
    next();
  },
})
export default class TindakanMedik extends Vue {
  disSaving = true;
  disDiag = true;
  disTambah = true;
  dokter = {};
  timeShow = false;
  tglShow = false;
  maxDate = moment().format("YYYY-MM-DD");
  time = moment().format("HH:mm");
  tglIsi = moment().format("YYYY-MM-DD");
  jam = moment().format("HHmm");
  selisih = null;
  rm = null;
  register = null;
  pasien = null;
  modalAksesTindakan = false;
  namaUnit = "";

  get tglIsiFormattedMomentjs() {
    return this.tglIsi ? moment(this.tglIsi).format("DD-MM-YYYY") : "";
  }
  get stateresume() {
    return storeResume.resume;
  }
  get stateuser() {
    return userModule.user;
  }
  get listDokter() {
    return storeDokter.listAll;
  }

  mounted() {
    window.onbeforeunload = function () {
      LockingRegister.unlockRegister("klinik");
      return "";
    };
  }

  formatTgl(date) {
    const [day, month, year] = date.split("-");
    return year + "-" + month + "-" + day;
  }
  loadData() {
    this.disDiag = false;
    this.disSaving = false;
    this.disTambah = false;
    storeBilling.getTindakanbyReg(this.register.no);
    storeBilling.getDiagnosis(this.register.no);
    storeBilling.getProcedure(this.register.no);
    this.tindakanByDateTime();
    // this.cekDokter();
  }
  // cekDokter() {
  //   if (this.stateresume[0] != null) {
  //     this.dokter = this.stateresume[0].dpjp;
  //   } else {
  //     this.dokter = this.register.dokter;
  //   }
  // }
  lockRegister() {
    const dt = Billing.lockRegister(
      this.register.no,
      this.stateuser.id,
      this.stateuser.unit_id,
      "klinik"
    );
    dt.then((dt) => {
      if (dt.status != 1) {
        appModule.sendErrorAlert(dt.message);
        this.batalAkses();
        this.modalAksesTindakan = false;
      }
    });
  }
  unlockRegister() {
    if (this.register) {
      const dt = Billing.unlockRegister(
        this.register.no,
        this.stateuser.id,
        "klinik"
      );
      dt.then((dt) => {
        if (dt.status != 1) {
          // appModule.sendErrorAlert(dt.message);
        }
      });
    }
  }
  tindakanByDateTime() {
    const request = {
      reg: this.register.no,
      tgl: this.tglIsi,
      jam: this.jam,
      unit: this.stateuser.unit_id,
    };
    storeBilling.getTindakanbyRequest(request);
  }

  cariReg(rm) {
    this.namaUnit = "";
    const tgl = moment().format("YYYY-MM-DD");
    this.register = null;
    this.pasien = null;
    const dt = DataPasien.getDataPasienLastReg(rm);
    dt.then((dt) => {
      if (dt["status"] != 1) {
        appModule.sendErrorAlert(dt["message"]);
      } else {
        if (dt.data[0].register) {
          this.pasien = dt.data[0];
          const reg = dt.data[0].register.no;
          // this.selisihDate(tgl, this.formatTgl(dt.data[0].register.tgl));
          // if (this.selisih > 14) {
          //   appModule.sendErrorAlert(
          //     "Nomor RM : " +
          //       dt.data[0].rm_dash +
          //       " Pasien masih terdaftar di tanggal " +
          //       dt.data[0].register.tgl
          //   );
          //   this.batalAkses();
          // } else {
          //   const dataReg = RegisterKunjunganSvc.get(reg);
          //   dataReg.then((dataReg) => {
          //     this.register = dataReg.data;
          //     this.lockRegister();
          //     this.namaUnit = this.pasien.register.unit.nama;
          //     RegisterKunjungan.getRegister(reg);
          //     if (this.register.dout != null) {
          //       appModule.sendErrorAlert(
          //         "Pasien sudah dipulangkan tanggal " + this.register.dout
          //       );
          //       this.loadData();
          //       this.disDiag = true;
          //       this.disSaving = true;
          //       this.disTambah = true;
          //     } else {
          //       if (this.register.unit == this.stateuser.unit_id) {
          //         this.loadData();
          //       } else {
          //         this.modalAksesTindakan = true;
          //       }
          //     }
          //   });
          // }

          // const dataReg = RegisterKunjunganSvc.get(reg);
          // dataReg.then((dataReg) => {
          //   this.register = dataReg.data;
          //   this.lockRegister();
          //   this.namaUnit = this.pasien.register.unit.nama;
          //   RegisterKunjungan.getRegister(reg);
          //   if (this.register.dout != null) {
          //     appModule.sendErrorAlert(
          //       "Pasien sudah dipulangkan tanggal " + this.register.dout
          //     );
          //     this.loadData();
          //     this.disDiag = true;
          //     this.disSaving = true;
          //     this.disTambah = true;
          //   } else {
          //     this.selisihDate(tgl, this.formatTgl(this.register.tgl));
          //     if (this.register.unit > "50") {
          //       // console.log("Ranap");
          //       if (this.register.unit == this.stateuser.unit_id) {
          //         this.loadData();
          //       } else {
          //         this.modalAksesTindakan = true;
          //       }
          //     } else {
          //       // console.log("Ralan", this.register);
          //       if (this.selisih > 14) {
          //         appModule.sendErrorAlert(
          //           "Pasien Nomor RM " +
          //             dt.data[0].rm_dash +
          //             " masih terdaftar di tanggal " +
          //             this.register.tgl
          //         );
          //         this.batalAkses();
          //       } else {
          //         if (this.register.unit == this.stateuser.unit_id) {
          //           this.loadData();
          //         } else {
          //           this.modalAksesTindakan = true;
          //         }
          //       }
          //     }
          //   }
          // });

          const dataReg = Billing.getStatusRegister(
            reg,
            this.stateuser.unit_id
          );
          dataReg.then((dataReg) => {
            this.register = dataReg.data;
            this.lockRegister();
            this.dokter = this.register.dokter;
            this.namaUnit = this.pasien.register.unit.nama;
            RegisterKunjungan.getRegister(reg);
            if (dataReg.status == "1") {
              this.loadData();
            } else if (dataReg.status == "2") {
              appModule.sendErrorAlert(dataReg.message);
              this.batalAkses();
            } else if (dataReg.status == "3") {
              this.modalAksesTindakan = true;
            } else if (dataReg.status == "4") {
              appModule.sendErrorAlert(dataReg.message);
              this.loadData();
              this.disDiag = true;
              this.disSaving = true;
              this.disTambah = true;
            } else if (dataReg.status == "5") {
              appModule.sendErrorAlert(dataReg.message);
              this.batalAkses();
            } else {
              appModule.sendErrorAlert(dataReg.message);
            }
          });
        } else {
          appModule.sendErrorAlert("Tidak ditemukan nomor register terakhir");
          this.batalAkses();
        }
      }
    });
  }
  kodeAkses() {
    this.loadData();
  }
  batalAkses() {
    this.rm = null;
    this.register = null;
    this.pasien = null;
    this.dokter = null;
    storeBilling.clearBilling();
    this.disDiag = true;
    this.disSaving = true;
    this.disTambah = true;
  }
  batalTindakan() {
    this.unlockRegister();
    this.batalAkses();
  }
  selisihDate(satu, dua) {
    this.selisih = null;
    const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
    const firstDate: any = new Date(satu);
    const secondDate: any = new Date(dua);
    this.selisih = Math.round(Math.abs((firstDate - secondDate) / oneDay));
  }

  @Watch("time")
  changeJam() {
    this.jam = this.time.substr(0, 2) + this.time.substr(3, 2);
  }
  // @Watch("stateresume")
  // changeResume() {
  //   if (this.stateresume[0]) {
  //     this.dokter = this.stateresume[0]["user"];
  //   }
  // }
  @Watch("rm")
  changeRm() {
    if (this.rm) {
      this.time = moment().format("HH:mm");
      this.tglIsi = moment().format("YYYY-MM-DD");
      if (this.rm.length == 6) {
        this.cariReg(this.rm);
      } else {
        this.unlockRegister();
        this.register = null;
        this.pasien = null;
        this.dokter = null;
        storeBilling.clearBilling();
        this.disDiag = true;
        this.disSaving = true;
        this.disTambah = true;
      }
    }
  }
  batalPeriksa() {
    this.cariReg(this.rm);
  }
}
